import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export type Colors = { background: string; text: string };

type PropsType = {
  badges: [string, Colors][];
};

const Wrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 1rem;
  z-index: 2;
  ${({ theme }) => `${theme.breakpoints.xxl} {
    bottom: unset;
    top: 0;
  }`}
`;

const Badge = styled.div<{ colors: Colors }>`
  padding: var(--space-25) var(--space-50);
  font-weight: 700;
  display: block;
  font-size: var(--font-size-50);
  width: fit-content;
  ${({ colors }) => `
    background: ${colors.background};
    color: ${colors.text};
  `}
  &:nth-child(2) {
    margin-top: var(--space-50);
  }
`;

const Badges = ({ badges }: PropsType) => {
  const { t } = useTranslation();

  if (badges.length === 0) {
    return null;
  }

  return (
    <Wrapper>
      {badges.map(([text, colors], i) => (
        <Badge key={i} colors={colors}>
          {t(text)}
        </Badge>
      ))}
    </Wrapper>
  );
};

export default Badges;
